{
  "otherOrganizations": "Autres organisations",
  "solutionIframe": "Contenu principal",
  "unloadPromptMessage": "Confirmez-vous votre choix ?"
}
